import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import validate from 'validate.js';
import { Grid, TextField } from '@mui/material';
import { SetFormState } from '../../../actions/IncidentTrackerActions';

const schema = {
	genericType: {
		presence: { allowEmpty: false, message: 'is required' },
	}
};

const useStyles = makeStyles((theme) => ({
	root: {},
	container: {
		marginTop: theme.spacing(3)
	},
	fields: {
		margin: theme.spacing(-1),
		display: 'flex',
		flexWrap: 'wrap',
		'& > *': {
			flexGrow: 1,
			margin: theme.spacing(1),
		},
	},
	submitButton: {
		marginTop: theme.spacing(2),
		width: '100%',
	},
	divider: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
	},
	noBorder: {
		border: 'none',
	}
}));

const IncidentConfigurationGenericTypeForm = (props) => {
	const classes = useStyles();
	const { defaultConfig = undefined, onChange, disabled, ...rest } = props;
	const [genericType, setGenericType] = useState(defaultConfig?.genericType ?? '');
	const id = defaultConfig?.id;
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.incidentTrackerReducer.formState);

	const updateFormState = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
	};

	const _handleGenericTypeChange = (event) => {
		setGenericType(event.target.value);
		updateFormState(event);
		onChange({ id, name: 'genericType', value: event.target.value });
	};

	useEffect(() => {
		const errors = validate(formState.values, schema);
		setFormState({
			...formState,
			isValid: !errors,
			errors: errors || {},
		});
	}, [formState.values]);

	useEffect(() => {
		setFormState({
			...formState,
			values: {
				genericType
			}
		});
	}, []);

	const hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));

	return (
		<Grid
			className={classes.container}
			container
			md={12}
			xs={12}
			spacing="8"
		>
			<Grid item md={6} xs={6}>
				<TextField
					id="genericType"
					name="genericType"
					label="Generic Type"
					hintText="Add a value"
					variant="outlined"
					disabled={disabled}
					fullWidth
					value={genericType || ''}
					onChange={_handleGenericTypeChange}
					error={hasError('genericType')}
					helperText={
						hasError('genericType') ? formState.errors.genericType[0] : null
					}
				/>
			</Grid>
		</Grid>
	);
};

IncidentConfigurationGenericTypeForm.propTypes = {
	onChange: PropTypes.func.isRequired,
	defaultConfig: PropTypes.object,
	disabled: PropTypes.bool
};

export default IncidentConfigurationGenericTypeForm;
